export enum EAdvancedFilterOptions {
  CONTAINS = 'CONTAINS',
  DOES_NOT_CONTAIN = 'DOES_NOT_CONTAIN',
  IS = 'IS',
  IS_NOT = 'IS_NOT',
  IS_NOT_MULTI = 'IS_NOT_MULTI',
  NOT_REGEX = 'NOT_REGEX',
  IS_EMPTY = 'IS_EMPTY',
  EXISTS = 'EXISTS',
  DOES_NOT_EXIST = 'DOES_NOT_EXIST',
  IS_NOT_EMPTY = 'IS_NOT_EMPTY',
  IS_GREATER_THAN = 'IS_GREATER_THAN',
  IS_GREATER_THAN_OR_EQUAL = 'IS_GREATER_THAN_OR_EQUAL',
  IS_LESS_THAN = 'IS_LESS_THAN',
  IS_LESS_THAN_OR_EQUAL = 'IS_LESS_THAN_OR_EQUAL',
  IS_CHECKED = 'IS_CHECKED',
  IS_NOT_CHECKED = 'IS_NOT_CHECKED',
  IS_BEFORE = 'IS_BEFORE',
  IS_AFTER = 'IS_AFTER',
  IS_BETWEEN = 'IS_BETWEEN',
  IS_ANY_OF = 'IS_ANY_OF',
  IS_NONE_OF = 'IS_NONE_OF',
  IS_ALL_OF = 'IS_ALL_OF',
  IS_NOT_ALL_OF = 'IS_NOT_ALL_OF',
  IS_EXACTLY = 'IS_EXACTLY',
  IS_A_PART_OF = 'IS_A_PART_OF',
  IS_FLAGGED = 'IS_FLAGGED',
  IS_NOT_FLAGGED = 'IS_NOT_FLAGGED',
  IS_POINT_LINKED = 'IS_POINT_LINKED',
  IS_NOT_POINT_LINKED = 'IS_NOT_POINT_LINKED',
  IS_UPCOMING = 'IS_UPCOMING',
  IS_OVERDUE = 'IS_OVERDUE',
  IS_DISMISSED = 'IS_DISMISSED',
  SHARED_BY_ME = 'SHARED_BY_ME',
  SHARED_WITH_ME = 'SHARED_WITH_ME',
  PERSONAL = 'PERSONAL',
}
